'use client';
import { IconChevronUp } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';

export const ScrollToTop = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const handleVisible = useCallback(() => {
    const position = window.scrollY;
    setScrollPosition(position);
    setShowScrollToTop(scrollPosition > 50);
  }, [scrollPosition]);

  useEffect(() => {
    window.addEventListener('scroll', handleVisible);
    return () => {
      window.removeEventListener('scroll', handleVisible);
    };
  }, [handleVisible]);

  return (
    <div className={`fixed right-2 bottom-2 z-[99] ${showScrollToTop ? '' : 'opacity-0'} transition-opacity`}>
      <button
        aria-label="Back to top"
        className="bg-secondary flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded"
        onClick={() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }}
      >
        <IconChevronUp width={50} height={50} color="white" />
      </button>
    </div>
  );
};
